import { App } from 'vue';
import vDis from './src/dis.ts';
declare const _default: {
    install: (app: App) => void;
};
export default _default;
export { vDis };
